import socketio from 'socket.io-client'

import { getToken } from './auth'

// const baseURL = 'http://10.0.0.108:3338'
// const baseURL = 'https://api.menuzer01.com'
const baseURL = 'https://api.ohmenu.com.br'
// const baseURL = 'http://localhost:3333'
// export const baseURL = 'https://test-api.menuzer01.com'

// export const baseURL = process.env.BASE_URL

// O token entra no handshake: só sockets autenticados recebem os pedidos da loja
// (newOrder/orderChange). A função é avaliada a cada (re)conexão.
const socket = socketio(baseURL, {
  transports: ['websocket'],
  auth: (cb) => cb({ token: getToken() })
})

// Chamar depois do login para o socket entrar nas salas das lojas do usuário
const reconnectSocket = () => {
  socket.disconnect()
  socket.connect()
}

// const botSocket = socketio('http://10.0.0.107:21465', {
//   transports: ['websocket']
// })

// const botSocket = socketio('https://api.whatsapp.zer01.info', {
//   transports: ['websocket']
// })

export {
  socket,
  reconnectSocket
  // botSocket
}
